'use client';

import { ReactNode } from 'react';

interface HeaderMotionProps {
  children: ReactNode;
  isVisible?: boolean;
  isTransparent?: boolean;
  animationTier?: 0 | 1 | 2 | 3;
}

/**
 * Simple header wrapper without animations
 * All animations are handled by CSS for consistency
 */
export const HeaderMotion = ({ 
  children, 
  isVisible = true,
  isTransparent: _isTransparent = false,
  animationTier: _animationTier = 0 
}: HeaderMotionProps) => {
  // Remove all Framer Motion animations and inline styles
  // Let CSS handle all positioning and animations
  return (
    <header
      style={{
        pointerEvents: isVisible ? 'auto' : 'none'
      }}
    >
      {children}
    </header>
  );
};

/**
 * Navigation item wrapper - no animations
 */
export const NavItemMotion = ({ 
  children, 
  index: _index = 0,
  animationTier: _animationTier = 0 
}: {
  children: ReactNode;
  index?: number;
  animationTier?: 0 | 1 | 2 | 3;
}) => {
  return <>{children}</>;
};

/**
 * Dropdown wrapper - simple visibility toggle
 */
export const DropdownMotion = ({ 
  children, 
  isOpen,
  animationTier: _animationTier = 0 
}: {
  children: ReactNode;
  isOpen: boolean;
  animationTier?: 0 | 1 | 2 | 3;
}) => {
  return isOpen ? <>{children}</> : null;
};